import apiClient from './api';

const dashboardService = {
  /** Operator: GET /api/dashboard  (ApiResponse<DashboardDto>) */
  async getOperatorDashboard() {
    const res = await apiClient.get('/dashboard');
    return res.data?.data ?? res.data;
  },

  /** Compliance layer: GET /api/compliance/dashboard  (ComplianceDashboardDto) */
  async getComplianceDashboard() {
    const res = await apiClient.get('/compliance/dashboard');
    return res.data?.data ?? res.data;
  },

  /** Admin: GET /api/admin/dashboard  (ApiResponse<object>) */
  async getAdminDashboard() {
    const res = await apiClient.get('/admin/dashboard');
    return res.data?.data ?? res.data;
  },
};

export default dashboardService;
